package com.devi3east.bashbuddy.cart.ui

sealed class CartUiEvent {
    data class ShowMessage(val message: String) : CartUiEvent()
    data class InventoryError(val message: String) : CartUiEvent()
    data object CheckoutSuccess : CartUiEvent()
    data object CheckoutCancelled : CartUiEvent()
}